<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage parking</div>
            <fieldset class="border p-3">
              <div></div>
              <div>
                <div class="parkingsLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading parkings...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemParkings"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'Print'">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm btn-rounded"
                        @click="viewParking(props.row.id)"
                      >
                        <i class="fa fa-print"></i>
                        Print
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Date",
          field: "parking_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Parking month",
          field: "parking_month",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Parking year",
          field: "parking_year",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Grand total",
          field: "grand_total",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Print",
          field: "Print",
          width: "100px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadParkings();
  },
  computed: {
    ...mapGetters(["systemParkings"]),
  },
  methods: {
    ...mapActions(["loadParkings", "viewParking"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/parkings/manageparkings.vue